import { Button, Heading, Modal } from '@zillow/constellation-10';
import { useState } from 'react';
import { useNotesModal_GetNotesDataQuery } from '../../../types/GraphqlTypes';
import useModal from '../../../hooks/useModal';
import type { OnContactsPageConversationNoteUpdate } from '../../../utils/contactsPageConversationsQueryParams';
import Notepad from '../../Notepad';

type NotesModalProps = {
  clientTimeZone: string;
  conversationId: string;
  listingAlias: string;
  onContactsPageConversationNoteUpdate?: OnContactsPageConversationNoteUpdate;
  shouldRefetchStatusLabels: boolean;
};

export default function NotesModal({
  clientTimeZone,
  conversationId,
  listingAlias,
  onContactsPageConversationNoteUpdate,
  shouldRefetchStatusLabels,
}: NotesModalProps): JSX.Element | null {
  const { data } = useNotesModal_GetNotesDataQuery({
    variables: {
      conversationId,
      listingAlias,
    },
    fetchPolicy: 'cache-only',
  });

  const notesData = data?.ZRM_getConversationById;
  const inquiry = notesData?.inquiry;
  const renterName = inquiry?.name || inquiry?.phone || '';

  const { clearModal } = useModal();
  const [resetAllInlineFeedbackChildState, setResetAllInlineFeedbackChildState] = useState(false);
  const [shouldSaveNoteText, setShouldSaveNoteText] = useState(false);

  const handleResetAllInlineFeedbackChildStateComplete = () => {
    setResetAllInlineFeedbackChildState(false);
  };

  const handleNoteSavingComplete = () => {
    setShouldSaveNoteText(false);
  };

  const handleOnClose = (): void => {
    setShouldSaveNoteText(true);
    clearModal();
  };

  const handleOnDoneClick = async (): Promise<void> => {
    setResetAllInlineFeedbackChildState(true);
    handleOnClose();
  };

  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && handleOnClose()}
      size={{
        base: 'fullScreen',
        md: 'xs',
      }}
      header={
        <Heading level={2} textStyle="heading-xs" css={{ textTransform: 'capitalize' }}>
          {renterName} Notes
        </Heading>
      }
      body={
        <Notepad
          clientTimeZone={clientTimeZone}
          conversationId={conversationId}
          listingAlias={listingAlias}
          onContactsPageConversationNoteUpdate={onContactsPageConversationNoteUpdate}
          shouldRefetchStatusLabels={shouldRefetchStatusLabels}
          resetAllInlineFeedbackChildState={resetAllInlineFeedbackChildState}
          onResetAllInlineFeedbackChildState={handleResetAllInlineFeedbackChildStateComplete}
          shouldSaveNoteText={shouldSaveNoteText}
          onHandleNoteSavingComplete={handleNoteSavingComplete}
        />
      }
      footer={
        <Button emphasis="filled" css={{ width: '100%' }} onClick={handleOnDoneClick} tone="brand">
          Done
        </Button>
      }
    />
  );
}
